export {default as AdapterApiService} from './AdapterApiService'; 